module.exports = "<img [src]=\"profilePhoto\" class=\"img-responsive\">\r\n"